import UKingdomFlag from "../../../assets/flags/united-kingdom.png";
import TurkeyFlag from "../../../assets/flags/turkey.png";
import GermanyFlag from "../../../assets/flags/germany.png";
import RussianFlag from "../../../assets/flags/russia.png";
import SaudiArabicFlag from "../../../assets/flags/saudi-arabia.png";
import UkraineFlag from "../../../assets/flags/ukraine.png";
import ItalianFlag from "../../../assets/flags/italian.png";
import IranFlag from "../../../assets/flags/IranFlag.png";
import chineseFlag from "../../../assets/flags/chineseFlag.png";
import frenchFlag from "../../../assets/flags/frenchflag.png";
import greeceFlag from "../../../assets/flags/greekFlag.png";
import japonFlag from "../../../assets/flags/japonFlag.png";
import koreanFlag from "../../../assets/flags/koreanFlag.png";
import pakistanFlag from "../../../assets/flags/pakistanFlag.png";
import romanianFlag from "../../../assets/flags/romaniaFlag.png";
export const flags = {
  UKingdomFlag,
  SaudiArabicFlag,
  TurkeyFlag,
  GermanyFlag,
  RussianFlag,
  UkraineFlag,
  ItalianFlag,
  IranFlag,
  chineseFlag,
  frenchFlag,
  greeceFlag,
  japonFlag,
  koreanFlag,
  pakistanFlag,
  romanianFlag,
};
